<template lang="pug">
  .modal-window(@click.self="closeModal")
    .modal-window__content(id="modal-window-content" :class="{ '--no-cover': modalData.noCover }")
      component.modal-window__component(
        :is="modalData.name"
        :title="modalData.title"
        :component-data="modalData.data"
        @close="closeModal"
      )

      button.modal-window__btn-close(@click="closeModal")
        i.el-icon-close
</template>

<script>
import { mapMutations } from "vuex";

import syncCalendarModal from "./modalContents/syncCalendarModal/syncCalendarModal";
import respMessage from "./modalContents/respMessage";
import actionVideo from "./modalContents/actionVideo";
import actionVebinar from "./modalContents/actionVebinar";
import showVideo from "./modalContents/showVideo";
import tresultEdit from "./modalContents/tresultEdit";
import createRequest from "./modalContents/createRequest";
import groupStatistic from "./modalContents/groupStatistic";
import detailStatistic from "./modalContents/detailStatistic";
import HomeWorkModal from "@/components/modalContents/HomeWorkModal";
import eventTab from "@/components/modalContents/eventTab";
export default {
  name: "Modal",

  components: {
    tresultEdit,
    actionVideo,
    showVideo,
    actionVebinar,
    respMessage,
    createRequest,
    groupStatistic,
    detailStatistic,
    syncCalendarModal,
    HomeWorkModal,
    eventTab
  },
  computed: {
    modalData() {
      return this.$store.state.modalData;
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEscapeKey);
  },
  methods: {
    ...mapMutations(["setModalData"]),
    closeModal() {
      this.setModalData(null);
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss">
.modal-window {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 22;
  scrollbar-width: 0;
  scrollbar-color: transparent transparent;

  &__component {
    order: 2;
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: 20px 20px 20px 20px;
    max-width: 80%;
    max-height: 90%;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    position: relative;
    background-color: $basic-white;
    overflow-y: hidden;

    &.--no-cover {
      padding: unset;
      width: unset;
      height: unset;
      max-height: unset;
      max-width: unset;
      border-radius: unset;
      justify-content: center;
      background-color: unset;
    }
  }

  &__btn-close {
    flex-shrink: 0;
    order: 1;
    z-index: 10;
    margin-top: 0;
    margin-left: auto;
    margin-bottom: 10px;
    background-color: $basic-white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    cursor: pointer;
    position: sticky;
    border: 1px solid $secondary-text-clr;
    padding: 0;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    right: 0;
    top: 0;
    color: $brand-clr-1;
    border: 1px solid $brand-clr-1;

    &:hover {
      color: lighten($color: $brand-clr-1, $amount: 10%);
      border-color: lighten($color: $brand-clr-1, $amount: 10%);
    }
  }
}
@media (max-width: 400px) {
  .modal-window {

    &__content {
      padding-bottom: 0;
      max-width: 100%;
      max-height: 100%;
      border-radius: 0;
    }
  }
}
</style>
